import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditCategorySectionModal } from '../../../../-components/SectionModal/CategorySectionModal';

export const Route = createFileRoute(
    '/_authenticated/placement/$tenantId/category/$categoryId/sections/$sectionId',
)({
    context: ({ params }) => ({
        sectionQuery: client.placement.section.get.queryOptions({
            params: { id: params.sectionId },
            query: {},
        }),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.sectionQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditCategorySectionModal,
});
